/**
 * Helpers for the manufacturer-acknowledgement (ack id) UI.
 *
 * A portal submission is proven by its confirmation screenshot asset (filename
 * `portal_submission_confirmation.png`, uploaded by PQCAgent on submit). Some
 * portals — notably FDA MedWatch — never issue an acknowledgement ID and
 * acknowledge only by email (which may never be ingested onto the case). Once
 * that screenshot exists we therefore show an explicit "no ack id for this
 * portal" note instead of an indefinite "waiting for manufacturer email"
 * placeholder, which for those portals would wait forever.
 */

// Must match PortalPanel's PORTAL_SCREENSHOT_BASE and the backend's
// _upload_screenshot file_name ("portal_submission_confirmation.png").
export const PORTAL_CONFIRMATION_ASSET_BASE = 'portal_submission_confirmation';

export const ACK_WAITING_PLACEHOLDER = 'Waiting for manufacturer email response...';
export const PORTAL_NO_ACK_PLACEHOLDER = 'This portal does not provide an acknowledgement ID.';

/**
 * Placeholder text for an empty ack-id field. When a portal case already has a
 * confirmation screenshot on record, the ack-id field says the portal issues no
 * acknowledgement ID; otherwise it keeps the "waiting for manufacturer email"
 * copy.
 */
export const ackFieldPlaceholder = (fieldId: string, hasPortalConfirmation: boolean): string =>
  hasPortalConfirmation && fieldId === 'ack_id'
    ? PORTAL_NO_ACK_PLACEHOLDER
    : ACK_WAITING_PLACEHOLDER;
